import memoizeOne from "memoize-one";

const isStaticRoute = memoizeOne((staticRoutes: string[], locationPathname: string) =>
    staticRoutes.some((route) => locationPathname.startsWith(route))
);

export default isStaticRoute;
